// extracted by mini-css-extract-plugin
export default {"trustedRetailerBanner":"w6-z","trustedRetailerTooltipWrapper":"x6-z"};